import { createReducer } from '@reduxjs/toolkit';
import { elevioActions } from '../elevio.actions';
const initialAiResponseState = {
    loading: false,
    data: null,
    tabStatus: 'reply',
};
export const aiResponseReducer = createReducer(initialAiResponseState, (builder) => {
    builder.addCase(elevioActions.aiResponse.aiResponseRequested, (state) => {
        state.loading = true;
        state.data = null;
    });
    builder.addCase(elevioActions.aiResponse.aiResponseReceived, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
    });
    builder.addCase(elevioActions.aiResponse.aiResponseError, (state) => {
        state.loading = false;
    });
    builder.addCase(elevioActions.aiResponse.aiResponseFinally, (state) => {
        state.loading = false;
    });
    builder.addCase(elevioActions.aiResponse.updateReplySectionTabStatus, (state, action) => {
        state.tabStatus = action.payload.tabStatus;
    });
});
